<div class="tyalls-table-name mb-3">
	<h6 class="tyalls-table-heading">Account Information – <span class="font-light">{{ propertyName }}</span></h6>
</div>

<div class="panel">
	<div class="top-grid">
		<!-- Left -->
		<div>
			<div class="field">
				<div class="label">Plan Name:
					@if (!isLoading && remainingDaysLeft >= 1) {
						<span class="trial-badge">
				Free trial {{ remainingDaysLeft }} day{{ remainingDaysLeft === 1 ? '' : 's' }} left
			</span>
					}

				</div>

				<div class="box wide flex items-center justify-between">
					<span>{{ planName || (isLoading ? 'Loading…' : '—') }}</span>
				</div>
			</div>

			<div class="field">
				<div class="label">Commencement Date:</div>
				<div class="box wide">{{ commencementDate || (isLoading ? 'Loading…' : '—') }}</div>
			</div>

			<div class="field">
				<div class="label">Account Owner:</div>
				<div class="box wide">{{ accountOwner || (isLoading ? 'Loading…' : '—') }}</div>
			</div>
		</div>

		<!-- Right -->
		<div>
			<div class="field two">
				<div>
					<div class="label">Plan Details:</div>
					<div class="box">{{ planDetails || (isLoading ? 'Loading…' : '—') }}</div>
				</div>
				<div>
					<div class="label">Features</div>
					<div class="box">{{ features || (isLoading ? 'Loading…' : '—') }}</div>
				</div>
			</div>

			<div class="field two">
				<div>
					<div class="label">Billing Cycle:</div>
					<div class="box">{{ billingCycle || (isLoading ? 'Loading…' : '—') }}</div>
				</div>
			</div>
		</div>
	</div>
</div>

<div class="spacer"></div>
